export default class Contract {
    // 获取合同
    static getContractList (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaContract/list', 'post', data, axiosOption, httpOption);
    }
    // 获取全部供货方
    static getSupplierListAll (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaContract/listAllSupplier', 'post', data, axiosOption, httpOption);
    }
    // 获取全部项目
    static getProjectAll (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaProject/list', 'post', data, axiosOption, httpOption);
    }
    // 获取全部项目
    static getProjectAllList (sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaProject/projectList', 'post', data, axiosOption, httpOption);
  }
  // 付款审批单获取金额 
    static getProjectAmount(sender, data, axiosOption, httpOption) {
      return sender.doUrl('/admin/upms/oaPayApproval/projectAmount', 'post', data, axiosOption, httpOption);
  }
  // 获取请假天数
  static getQJdays(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaPayApproval/getQjDays', 'get', data, axiosOption, httpOption);
  }
  // 合同流程-获取项目列表
  static getContractProjectList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaProject/projectListByQuery', 'post', data, axiosOption, httpOption);
  }
  // 根据供货方id查询供货方详情 
  static getSupplierById (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaSupplier/getById', 'get', data, axiosOption, httpOption);
  }
  // 根据项目id查询合同列表
  static getContractListByProjectId (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/mainListByQuery', 'get', data, axiosOption, httpOption);
  }
  // addSupplier
  static addSupplier (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaSupplier/add', 'post', data, axiosOption, httpOption);
  }
  // 新增合同
  static addContract (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/addContract', 'post', data, axiosOption, httpOption);
  }
  // 编辑合同
  static updateContract (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/updateContract', 'post', data, axiosOption, httpOption);
  }
  // 查询合同列表
  static getContractPageList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/pageList', 'get', data, axiosOption, httpOption);
  }
  // 合同管理列表
  static getContractManageList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/getContractList', 'post', data, axiosOption, httpOption);
  }
  // 导出合同列表
  static exportContractList (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/exportContractList', 'post', data, axiosOption, httpOption);
  }
  // 设置合同实际结算金额 
  static updateFinalSettlementAmount (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/updateFinalSettlementAmount', 'post', data, axiosOption, httpOption);
  }
  // 查询合同累计金额
  static sumContractAmount (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/sumContractAmount', 'get', data, axiosOption, httpOption);
  }
  // 撤回合同流程 /admin/upms/oaContract/revokeToStart
  static revokeToStart (sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/revokeToStart', 'post', data, axiosOption, httpOption);
  }
  // 盖章
  static updateSeal(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/updateSeal', 'post', data, axiosOption, httpOption);
  }
  // 盖章（按ID）
  static updateSealById(sender, data, axiosOption, httpOption) {
    return sender.doUrl('/admin/upms/oaContract/updateSealById', 'post', data, axiosOption, httpOption);
  }
}